import type { ChipProps } from '@mui/material/Chip'
import Chip from '@mui/material/Chip'

export { ProjectStatus }

type Props = {
  status:
    | 'Intake'
    | 'Werkvoorbereiding'
    | 'In uitvoering'
    | 'Oplevering'
    | 'Gepauzeerd'
    | 'Gereed'
    | 'Geannuleerd'
    | 'Geen combiuitvoering'
    | string
}
const ProjectStatus = ({ status: statusFromProps }: Props) => {
  const status = statusFromProps.toLowerCase()
  let color: ChipProps['color'] = 'default'

  switch (status) {
    case 'intake':
      color = 'primary'
      break

    case 'werkvoorbereiding':
      color = 'secondary'
      break

    case 'gereed':
    case 'in uitvoering':
      color = 'success'
      break

    case 'oplevering':
      color = 'info'
      break

    case 'gepauzeerd':
      color = 'warning'
      break

    case 'geannuleerd':
      color = 'error'
      break

    default:
    case 'geen combiuitvoering':
      color = 'default'
      break
  }

  return <Chip label={statusFromProps} color={color} size="small" />
}
